<template>
  <div id="components-layout-demo-basic">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <defs>
        <symbol id="icon-submit" viewBox="0 0 489.4 489.4">
          <g><path d="M382.4,422.75h-79.1H282h-4.6v-106.1h34.7c8.8,0,14-10,8.8-17.2l-67.5-93.4c-4.3-6-13.2-6-17.5,0l-67.5,93.4c-5.2,7.2-0.1,17.2,8.8,17.2h34.7v106.1h-4.6H186H94.3c-52.5-2.9-94.3-52-94.3-105.2c0-36.7,19.9-68.7,49.4-86c-2.7-7.3-4.1-15.1-4.1-23.3c0-37.5,30.3-67.8,67.8-67.8c8.1,0,15.9,1.4,23.2,4.1c21.7-46,68.5-77.9,122.9-77.9c70.4,0.1,128.4,54,135,122.7c54.1,9.3,95.2,59.4,95.2,116.1C489.4,366.05,442.2,418.55,382.4,422.75z" /></g>
        </symbol>
				<symbol id="icon-like" viewBox="0 0 1024 1024">
          <g><path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4-20.5-21.5-48.1-33.4-77.9-33.4-52 0-98 35-111.8 85.1l-85.9 311h-0.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-0.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"/></g>
        </symbol>
				<symbol id="icon-dislike" viewBox="0 0 1024 1024">
          <g><path d="M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4-8.3-3.6-17.2-5.4-26.5-5.4H273v428h0.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"/></g>
        </symbol>
        <symbol id="icon-correct" viewBox="0 0 1024 1024">
          <g><path d="M994.305189 166.160367c-39.944757-40.916898-104.705714-40.916898-144.652518 0L391.586025 635.503848 174.610318 413.1916c-39.946804-40.935318-104.706737-40.935318-144.643308 0-39.956014 40.917922-39.956014 107.283422 0 148.214646l289.295825 296.41906c39.945781 40.936341 104.700597 40.936341 144.647401 0l530.394952-543.450293C1034.251993 273.447882 1034.251993 207.091592 994.305189 166.160367z" p-id="13161"></path></g>
        </symbol>
        <symbol id="icon-wrong" viewBox="0 0 1024 1024">
          <g><path d="M886.784 746.496q29.696 30.72 43.52 56.32t-4.608 58.368q-4.096 6.144-11.264 14.848t-14.848 16.896-15.36 14.848-12.8 9.728q-25.6 15.36-60.416 8.192t-62.464-34.816l-43.008-43.008-57.344-57.344-67.584-67.584-73.728-73.728-131.072 131.072q-60.416 60.416-98.304 99.328-38.912 38.912-77.312 48.128t-68.096-17.408l-7.168-7.168-11.264-11.264-11.264-11.264q-6.144-6.144-7.168-8.192-11.264-14.336-13.312-29.184t2.56-29.184 13.824-27.648 20.48-24.576q9.216-8.192 32.768-30.72l55.296-57.344q33.792-32.768 75.264-73.728t86.528-86.016q-49.152-49.152-93.696-93.184t-79.872-78.848-57.856-56.832-27.648-27.136q-26.624-26.624-27.136-52.736t17.92-52.736q8.192-10.24 23.552-24.064t21.504-17.92q30.72-20.48 55.296-17.92t49.152 28.16l31.744 31.744q23.552 23.552 58.368 57.344t78.336 76.288 90.624 88.576q38.912-38.912 76.288-75.776t69.632-69.12 58.368-57.856 43.52-43.008q24.576-23.552 53.248-31.232t55.296 12.8q1.024 1.024 6.656 5.12t11.264 9.216 10.752 9.728 7.168 5.632q27.648 26.624 27.136 57.856t-27.136 57.856q-18.432 18.432-45.568 46.08t-60.416 60.416-70.144 69.632l-77.824 77.824q37.888 36.864 74.24 72.192t67.584 66.048 56.32 56.32 41.472 41.984z" p-id="18690"></path></g>
        </symbol>
      </defs>
    </svg>
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/Q&A.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Dory</span>
            </div>
          </router-link>
        </div>

      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div class="leave">
            <div class="leave-menu">
              <div class="info-prof" style="display: flex">
                <div class="info-prof-avatar">
                  <img v-if="userInfoList.profile_picture"
                       :src="userInfoList.profile_picture"
                       alt="">
                  <img v-else
                       src="@/assets/Images/defaultavatar.jpeg"
                       alt="">
                </div>
                <div style="margin-left:12px;display:flex;flex-direction:column">
                  <div class="info-prof-name">{{ userInfoList.nickname }}</div>
                  <div class="info-prof-offer">{{ userInfoList.job_title }}</div>
                </div>
              </div>
              <!--   切换   -->
              <a-menu
                style="width: 256px"
                :default-selected-keys="defaultShowMenu"
                @click="tabChangeClick">
                <a-menu-item key="0">
                  <img ref="newIcon" src="@/assets/Icons/new.svg" alt="" style="width:24px;height:24px;">
                  <img ref="newIconBlue" src="@/assets/Icons/new-blue.svg" alt=""
                       style="width:24px;height:24px;">
                  <span>TGIF Questions</span>
                </a-menu-item>
                <a-menu-item v-for="(item) in currentTopicList" :key="item.id">
                  <img ref="newOtherIcon" src="@/assets/Icons/new-other.svg" alt=""  style="width:24px;height:24px;" :style="{display:item.id == currentTopicId ? 'none' : 'initial'}">
                  <img ref="newOtherIconBlue" src="@/assets/Icons/new-other-blue.svg" alt=""
                       style="width:24px;height:24px;display: none" :style="{display:item.id == currentTopicId ? 'initial' : 'none'}">
                  <span>{{item.topic_name}}</span>
                </a-menu-item>
                <a-menu-item key="100">
                  <img ref="historyIcon" src="@/assets/Icons/history.svg" alt="" style="width:24px;height:24px;">
                  <img ref="historyIconBlue" src="@/assets/Icons/history-blue.svg" alt=""
                       style="width:24px;height:24px;">
                  <span>TGIF History</span>
                </a-menu-item>
                <a-menu-item key="200">
                  <img ref="myselfIcon" src="@/assets/Icons/new-other.svg" alt="" style="width:24px;height:24px;">
                  <img ref="myselfIconBlue" src="@/assets/Icons/new-other-blue.svg" alt=""
                       style="width:24px;height:24px;">
                  <span>My Questions</span>
                </a-menu-item>
              </a-menu>
            </div>
            <div class="leave-content">
              <div v-if="timeOffRequestVisible" class="timeoff-request">
                <a-spin :spinning="timeOffRequest">
                  <div class="request-title">
                    <span>TGIF Q&A</span>
                    <div style="display:flex;align-items:center;">
                      <a href="https://docs.google.com/document/d/11dlYF9rKYp3FBEaIDSMe6xczTUofKQihe3cJzVQaGQY" target="_blank" style="margin-right:24px;">Guideline</a>
                      <a href="https://docs.google.com/spreadsheets/d/1NYf7mXkZaysL7hb8FjwdWJD2ioElkm9YM3EhPTR18sI" target="_blank" style="margin-right:24px;">Feedback</a>
                      <div type="primary" class="submit-btn" @click="questionSubmitVisible">Suggest a Question</div>
                    </div>
                  </div>
                  <a-modal
                    width="600px"
                    title="Edit"
                    :visible="questionSubmitModalVisible"
                    :confirm-loading="questionSubmitConfirmLoading"
                    @ok="questionSubmitOk"
                    @cancel="questionSubmitCancel"
                  >
                    <div class="tgif-question">
                      <a-textarea
                        placeholder="Enter Your Question"
                        style="width:100%;height:100px;resize:none;"
                        v-model="question"
                        :maxLength='60'
                      ></a-textarea>
                      <div style="width:100%;display:flex;justify-content:space-between;margin-top:5px;">
                        <div>(60字以内)</div>
                        <a-checkbox @change="questionTypeChange">匿名提问</a-checkbox>
                      </div>
                      
										</div>
                  </a-modal>
									<div class="request-content">
                    <div class="view-report-content">
                      <span style="font-family: GoogleSans-Bold;font-size: 18px;margin-bottom:12px;">Please Vote on this Question</span>
                    </div>
                    <a-carousel ref="question" class="question-card-wrap" :dots="false" autoplay>
                      <div  v-for="item in questionListLast" :key='item.id'>
                        <div class="question-card">
                          <div class="question-content">{{item.question}}</div>
                          <div class="question-select-wrap">
                            <div class="question-title">Good Question?</div>
                            <div class="question-selection"> 
                              <div class="tgif-list-item-like" :style="{background:item.hold == '1' ? '#45b97c' : '#ffffff'}" @click="likeQuestion(item.id,item.hold,1)">
                              <!-- <div class="tgif-list-item-like" @click="likeQuestion(item.id,item.hold,1)"> -->
                                <svg :fill="item.hold == '1' ? '#ffffff' : ' '"  viewBox="0 0 489.4 489.4" height="40px">
                                  <use xlink:href="#icon-correct"></use>
                                  <!-- <use xlink:href="#icon-correct" :fill="item.hold == '1' ? '#45b97c' : '#000000'"></use> -->
                                </svg>
                              </div>
                              <div class="tgif-list-item-dislike" :style="{background:item.hold == '2' ? '#ed1941' : '#ffffff'}" @click="likeQuestion(item.id,item.hold,2)">
                              <!-- <div class="tgif-list-item-dislike" @click="likeQuestion(item.id,item.hold,2)"> -->
                                <svg :fill="item.hold == '2' ? '#ffffff' : ' '" viewBox="0 0 489.4 489.4" height="40px">
                                  <use xlink:href="#icon-wrong"></use>
                                  <!-- <use xlink:href="#icon-wrong" :fill="item.hold == '2' ? '#ed1941' : '#000000'"></use> -->
                                </svg>
                              </div>
                            </div>
                            <a-button class="question-skip" @click="nextQuestion">Next Question</a-button>
                          </div>
                        </div>
                        <div style="color:#aaaaaa;font-size:16px;"><span style="">{{item.nickname}}</span><span style="margin:0 20px;">·</span><span >{{item.times}}</span></div>
                      </div>
                    </a-carousel>
                    <div class="view-report-content" style="margin-top:20px;margin-bottom:12px;display:flex;justify-content:space-between;">
                      <span style="font-family: GoogleSans-Bold;font-size: 18px;">Currently in the Lead</span>
                      <div>
                        <a-button :type="questionListOrder === 3 ? 'primary' : ''" @click="changeQuestionNum(3)" style="margin-right:8px;">需求量</a-button>
                        <a-button :type="questionListOrder === 2 ? 'primary' : ''"  @click="changeQuestionNum(2)" style="margin-right:8px;">互动量</a-button>
                        <a-button :type="questionListOrder === 1 ? 'primary' : ''" @click="changeQuestionNum(1)">最新发布</a-button>
                      </div>
                    </div>
                    <div class="question-list">
                      <div style="margin-bottom:20px;padding-bottom:15px;border-bottom:2px solid #cccccc;" v-for="item in questionListNum" :key='item.id'>
                        <div class="question-item">
                          <div class="question-item-content">{{item.question}}</div>
                          <div class="question-item-result">
                            <!-- 可点击 -->
                            <div class="question-item-select-wrap" @click="likeQuestion(item.id,item.hold,1)">
                              <svg viewBox="0 0 489.4 489.4" height="20px" :fill="item.hold == 1 ? '#45b97c' : '#000000'" style="border:1px solid #cccccc;padding:3px;"><use xlink:href="#icon-correct"></use></svg>
                              <div class="question-correct-width">
                                <span :style="{width:isNaN(item.likes / item.sum) ? '0' : (item.likes / item.sum) * 100 + '%'}"></span>
                              </div>
                              <span class="question-correct-num">{{item.likes}}</span>
                            </div>
                            <!-- 可点击 -->
                            <div class="question-item-select-wrap" @click="likeQuestion(item.id,item.hold,2)">
                              <svg viewBox="0 0 489.4 489.4" height="20px" :fill="item.hold == 2 ? '#ed1941' : '#000000'" style="border:1px solid #cccccc;padding:3px;"><use xlink:href="#icon-wrong"></use></svg>
                              <div class="question-wrong-width">
                                <span :style="{width:isNaN(item.dislikes / item.sum) ? '0' : (item.dislikes / item.sum) * 100 + '%'}"></span>
                              </div>
                              <span class="question-wrong-num">{{item.dislikes}}</span>
                            </div>
                          </div>
                        </div>
                        <div style="color:#aaaaaa;font-size:14px;margin-top:15px;"><span style="">{{item.nickname}}</span><span style="margin:0 20px;">·</span><span >{{item.times}}</span></div>
                      </div>
                    </div>
                    <div style="display:flex;justify-content:flex-end;font-family:GoogleSans-Bold;">
                      <div class="submit-btn" @click="questionSubmitVisible">Suggest a Question</div>
                    </div>
									</div>
                </a-spin>
              </div>
              <div v-if="timeOffRequestTopicVisible" class="timeoff-request">
                <a-spin :spinning="timeOffTopicRequest">
                  <div class="request-title">
                    <span>{{currentTopicName}}</span>
                    <div style="display:flex;align-items:center;">
                      <div type="primary" class="submit-btn" @click="questionSubmitVisible">Suggest a Question</div>
                    </div>
                  </div>
                  <a-modal
                    width="600px"
                    title="Edit"
                    :visible="questionSubmitModalVisible"
                    :confirm-loading="questionSubmitConfirmLoading"
                    @ok="questionTopicSubmitOk"
                    @cancel="questionSubmitCancel"
                  >
                    <div class="tgif-question">
                      <a-textarea
                        placeholder="Enter Your Question"
                        style="width:100%;height:100px;resize:none;"
                        v-model="question"
                      ></a-textarea>
                      <div style="width:100%;display:flex;justify-content:space-between;margin-top:5px;">
                        <!-- <div>(60字以内)</div> -->
                        <a-checkbox @change="questionTypeChange">匿名提问</a-checkbox>
                      </div>
										</div>
                  </a-modal>
									<div class="request-content">
                    <div class="view-report-content">
                      <span style="font-family: GoogleSans-Bold;font-size: 18px;">Please Vote on this Question</span>
                    </div>
                    <a-carousel ref="question" class="question-card-wrap" :dots="false" autoplay>
                      <div  v-for="item in currentTopicListLast" :key='item.id'>
                        <div class="question-card">
                          <div class="question-content">{{item.question}}</div>
                          <div class="question-select-wrap">
                            <div class="question-title">Good Question?</div>
                            <div class="question-selection"> 
                              <div class="tgif-list-item-like" :style="{background:item.hold == '1' ? '#45b97c' : '#ffffff'}" @click="holdTopic(item.id,item.hold,1)">
                              <!-- <div class="tgif-list-item-like" @click="likeQuestion(item.id,item.hold,1)"> -->
                                <svg :fill="item.hold == '1' ? '#ffffff' : ' '"  viewBox="0 0 489.4 489.4" height="40px">
                                  <use xlink:href="#icon-correct"></use>
                                  <!-- <use xlink:href="#icon-correct" :fill="item.hold == '1' ? '#45b97c' : '#000000'"></use> -->
                                </svg>
                              </div>
                              <div class="tgif-list-item-dislike" :style="{background:item.hold == '2' ? '#ed1941' : '#ffffff'}" @click="holdTopic(item.id,item.hold,2)">
                              <!-- <div class="tgif-list-item-dislike" @click="likeQuestion(item.id,item.hold,2)"> -->
                                <svg :fill="item.hold == '2' ? '#ffffff' : ' '" viewBox="0 0 489.4 489.4" height="40px">
                                  <use xlink:href="#icon-wrong"></use>
                                  <!-- <use xlink:href="#icon-wrong" :fill="item.hold == '2' ? '#ed1941' : '#000000'"></use> -->
                                </svg>
                              </div>
                            </div>
                            <a-button class="question-skip" @click="nextQuestion">Next Question</a-button>
                          </div>
                        </div>
                        <div style="color:#aaaaaa;font-size:16px;"><span style="">{{item.nickname}}</span><span style="margin:0 20px;">·</span><span >{{item.addtime}}</span></div>
                      </div>
                    </a-carousel>
                    <div class="view-report-content" style="margin-top:20px;">
                      <span style="font-family: GoogleSans-Bold;font-size: 18px;">Currently in the Lead</span>
                    </div>
                    <div class="question-list">
                      <div style="margin-bottom:20px;padding-bottom:15px;border-bottom:2px solid #cccccc;" v-for="item in currentTopicListNum" :key='item.id'>
                        <div class="question-item">
                          <div class="question-item-content">{{item.question}}</div>
                          <div class="question-item-result">
                            <!-- 可点击 -->
                            <div class="question-item-select-wrap" @click="holdTopic(item.id,item.hold,1)">
                              <svg viewBox="0 0 489.4 489.4" height="20px" :fill="item.hold == 1 ? '#45b97c' : '#000000'" style="border:1px solid #cccccc;padding:3px;"><use xlink:href="#icon-correct"></use></svg>
                              <div class="question-correct-width">
                                <span :style="{width:isNaN(item.likes / item.sum) ? '0' : (item.likes / item.sum) * 100 + '%'}"></span>
                              </div>
                              <span class="question-correct-num">{{item.likes}}</span>
                            </div>
                            <!-- 可点击 -->
                            <div class="question-item-select-wrap" @click="holdTopic(item.id,item.hold,2)">
                              <svg viewBox="0 0 489.4 489.4" height="20px" :fill="item.hold == 2 ? '#ed1941' : '#000000'" style="border:1px solid #cccccc;padding:3px;"><use xlink:href="#icon-wrong"></use></svg>
                              <div class="question-wrong-width">
                                <span :style="{width:isNaN(item.dislikes / item.sum) ? '0' : (item.dislikes / item.sum) * 100 + '%'}"></span>
                              </div>
                              <span class="question-wrong-num">{{item.dislikes}}</span>
                            </div>
                          </div>
                        </div>
                        <div style="color:#aaaaaa;font-size:14px;margin-top:15px;"><span style="">{{item.nickname}}</span><span style="margin:0 20px;">·</span><span >{{item.addtime}}</span></div>
                      </div>
                    </div>
                    <div style="display:flex;justify-content:flex-end;font-family:GoogleSans-Bold;">
                      <div class="submit-btn" @click="questionSubmitVisible">Suggest a Question</div>
                    </div>
									</div>
                </a-spin>
              </div>
              <div v-if="timeOffHistoryVisible" class="timeoff-request" style="box-shadow:none;">
                <a-spin :spinning="timeOffHistory">
                  <div class="timeoff-history-title" style="width:100%;">
                    <div class="history-title-text" style="display:flex;justify-content:space-between;">
                      <span>History ({{this.yearValue}})</span>
                    </div>
                    <a-select
                            class="year-select"
                            style="margin-right:0;"
                            v-model="yearValue"
                            @change="yearChange"
                          >
                          <a-select-option v-for="item in yearList" :key="item" :value="item">{{item}}</a-select-option>
                        </a-select>
                     <!-- <a-popconfirm
                      title="提交后无法撤回，是否继续提交？"
                      ok-text="确认"
                      cancel-text="取消"
                      @confirm="talkedQuestion"
                      @cancel="talkedQuestionCancel"
                    >
                      <a-button v-if="questionsDeal" type="primary">问题已解决</a-button>
                    </a-popconfirm> -->
                  </div>
									<div class="timeoff-history-content">
                    <div class="view-report-content" style="margin-top:40px;flex-direction:column;">
                      <div v-for="item in historyQuestionList" :key="item.month">
                        <span style="font-family: GoogleSans-Bold;font-size: 24px;">{{item.months}}</span>
                        <div class="question-list" >
                          <div style="margin-bottom:20px;padding-bottom:15px;border-bottom:2px solid #cccccc;" v-for="single in item.detail" :key='single.id'>
                            <div class="question-item" :style="{color:single.history == 1 ? '#cccccc' : ''}">
                              <div class="question-item-content">{{single.question}}</div>
                              <div class="question-item-result">
                                <div class="question-item-select-wrap history">
                                  <svg viewBox="0 0 489.4 489.4" height="14px" :fill="single.history == 1 ? '#cccccc' : ''"><use xlink:href="#icon-correct"></use></svg>
                                  <div class="question-correct-width">
                                    <span :style="{width:isNaN(single.likes / single.sum) ? '0' : (single.likes / single.sum) * 100 + '%',background:single.history == 1 ? '#aaaaaa' : ''}"></span>
                                  </div>
                                  <span class="question-correct-num">{{single.likes}}</span>
                                </div>
                                <!-- 可点击 -->
                                <div class="question-item-select-wrap history">
                                  <svg viewBox="0 0 489.4 489.4" height="14px" :fill="single.history == 1 ? '#cccccc' : ''"><use xlink:href="#icon-wrong"></use></svg>
                                  <div class="question-wrong-width">
                                    <span :style="{width:isNaN(single.dislikes / single.sum) ? '0' : (single.dislikes / single.sum) * 100 + '%',background:single.history == 1 ? '#dddddd' : ''}"></span>
                                  </div>
                                  <span class="question-wrong-num">{{single.dislikes}}</span>
                                </div>
                              </div>
                            </div>
                            <div style="color:#aaaaaa;font-size:14px;margin-top:15px;"><span style="">{{single.is_anonymous === 0 ? 'Anonymous' : single.nickname}}</span><span style="margin:0 20px;">·</span><span >{{single.times}}</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
									</div>
                </a-spin>
              </div>
              <div v-if="timeOffMyselfVisible" class="timeoff-request" style="box-shadow:none;">
                <a-spin :spinning="timeOffHistory">
                  <div class="timeoff-history-title" style="width:100%;">
                    <div class="history-title-text" style="display:flex;justify-content:space-between;">
                      <span>My Questions ({{this.myselfYearValue}})</span>
                    </div>
                    <a-select
                            class="year-select"
                            style="margin-right:0;"
                            v-model="myselfYearValue"
                            @change="myselfYearChange"
                          >
                          <a-select-option v-for="item in yearList" :key="item" :value="item">{{item}}</a-select-option>
                        </a-select>
                  </div>
									<div class="timeoff-history-content">
                    <div class="view-report-content" style="margin-top:40px;flex-direction:column;">
                      <div v-for="item in myselfQuestionList" :key="item.month">
                        <span style="font-family: GoogleSans-Bold;font-size: 24px;">{{item.months}}</span>
                        <div class="question-list" >
                          <div style="margin-bottom:20px;padding-bottom:15px;border-bottom:2px solid #cccccc;" v-for="single in item.detail" :key='single.id'>
                            <div class="question-item" :style="{color:single.history == 1 ? '#cccccc' : ''}">
                              <div class="question-item-content">{{single.question}}</div>
                              <div class="question-item-result">
                                <div class="question-item-select-wrap history">
                                  <svg viewBox="0 0 489.4 489.4" height="14px" :fill="single.history == 1 ? '#cccccc' : ''"><use xlink:href="#icon-correct"></use></svg>
                                  <div class="question-correct-width">
                                    <span :style="{width:isNaN(single.likes / single.sum) ? '0' : (single.likes / single.sum) * 100 + '%',background:single.history == 1 ? '#aaaaaa' : ''}"></span>
                                  </div>
                                  <span class="question-correct-num">{{single.likes}}</span>
                                </div>
                                <!-- 可点击 -->
                                <div class="question-item-select-wrap history">
                                  <svg viewBox="0 0 489.4 489.4" height="14px" :fill="single.history == 1 ? '#cccccc' : ''"><use xlink:href="#icon-wrong"></use></svg>
                                  <div class="question-wrong-width">
                                    <span :style="{width:isNaN(single.dislikes / single.sum) ? '0' : (single.dislikes / single.sum) * 100 + '%',background:single.history == 1 ? '#dddddd' : ''}"></span>
                                  </div>
                                  <span class="question-wrong-num">{{single.dislikes}}</span>
                                </div>
                              </div>
                            </div>
                            <div style="color:#aaaaaa;font-size:14px;margin-top:15px;display: flex;justify-content: space-between;">
                              <div>
                                <span style="">{{single.is_anonymous === 0 ? 'Anonymous' : single.nickname}}</span>
                                <span style="margin:0 20px;">·</span>
                                <span >{{single.times}}</span>
                              </div>
                              <a-popconfirm
                                title="提交后不可撤销，是否继续提交？"
                                ok-text="确定"
                                cancel-text="取消"
                                @confirm="deleMyselfQuestion(single.id)"
                                @cancel="cancelDeleMyselfQuestion"
                              >
                                <a-button type="link">Delete</a-button>
                              </a-popconfirm>

                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
									</div>
                </a-spin>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'

moment.suppressDeprecationWarnings = true

export default {
  name:'TGIF',
  components:{
    Bug
  },
  data() {
    return {
      img:'',
      userInfoList: '',
      moment,                                     //  日期
      dateFormat: 'MM-DD-YYYY',                   //  日期格式
      todayDate: moment()                         //  今天日期
      .format()
      .slice(0, 10),
      yearValue:moment().format('YYYY'),
      myselfYearValue:moment().format('YYYY'),
      curUserId: '',                              //  当前用户id
      //  tab
      timeOffRequestVisible: true,                //  请假申请页面
      timeOffRequestTopicVisible:false,           //  其他类型页面
      timeOffHistoryVisible: false,               //  请假历史页面
      timeOffMyselfVisible: false,                //  当前用户页面
      timeOffRequest: false,                      //  问题页面加载状态
      timeOffTopicRequest: false,                 //  其它问题页面加载状态
      timeOffHistory: false,                      //  请假历史页面加载状态
      questionSubmitModalVisible:false,           //  提交问题框显示
      questionSubmitConfirmLoading:false,         //  提交问题确认状态
      questionListOrder:3,                  
      // 问题
      questionType:2,                             //  问题是否匿名
			question:'',										            //  提交问题
			questionListLast:'',								        //  问题列表(按日期)
			questionListNum:'',								          //  问题列表(按人数)
      historyQuestionList:'',                     //  历史问题
      myselfQuestionList:'',     
			operate:'',											            //  操作

      currentTopicId:'',                          //  当前专题id
      currentTopicName:'',                        //  当前专题name
      currentTopicList:'',                        //  当前专题列表
      currentTopicListLast:'',                    //  当前专题问题(按日期)
      currentTopicListNum:'',                     //  当前专题问题(按人数)

      questionsDeal:false,                        // 问题解决按钮权限
      defaultShowMenu:[],
      iconIndexArr:[],                            //  图标循环个数       
    }
  },
  computed: {
    // 年列表
    yearList:function() {
      const currentYear = new Date().getFullYear();
      return [currentYear, currentYear - 1, currentYear - 2]
    },
  },
  watch: {
    '$route'() {
      this.initPage()
    }
  },
  methods: {
    //  tab 切换
    tabChangeClick(e) {
      if (e.key == 0) {
        // if(this.iconIndexArr != 0) {
        //   this.iconIndexArr.forEach(item => {
        //     // this.$refs.newOtherIcon[item].style.display = 'initial'
        //     // this.$refs.newOtherIconBlue[item].style.display = 'none'
        //   })
        // }
        
        // this.$refs.newOtherIcon.style.display = 'initial'
        // this.$refs.newOtherIconBlue.style.display = 'none'
        this.$router.push({ path: '/dory/tgif-question' })
      }else if (e.key == 100) {
        // if(this.iconIndexArr != 0) {
        //   this.iconIndexArr.forEach(item => {
        //     // this.$refs.historyIcon[item].style.display = 'initial'
        //     // this.$refs.historyIconBlue[item].style.display = 'none'
        //   })
        // }
        
        // this.$refs.newOtherIcon.style.display = 'initial'
        // this.$refs.newOtherIconBlue.style.display = 'none'
        this.$router.push({ path: '/dory/tgif-history' })
      }else if (e.key == 200) {
        // if(this.iconIndexArr != 0) {
        //   this.iconIndexArr.forEach(item => {
        //     this.$refs.myselfIcon[item].style.display = 'initial'
        //     this.$refs.myselfIconBlue[item].style.display = 'none'
        //   })
        // }
        
        // this.$refs.newOtherIcon.style.display = 'initial'
        // this.$refs.newOtherIconBlue.style.display = 'none'
        this.$router.push({ path: '/dory/tgif-myself' })
      }else {
        this.currentTopicId = e.key
        // if(this.iconIndexArr != 0) {
        //   this.iconIndexArr.forEach(item => {
        //     if(item == this.currentTopicId - 1) {
        //       this.$refs.newOtherIcon[item].style.display = 'none'
        //       this.$refs.newOtherIconBlue[item].style.display = 'initial'
        //     }else {
        //       this.$refs.newOtherIcon[item].style.display = 'initial'
        //       this.$refs.newOtherIconBlue[item].style.display = 'none'
        //     }
        //   })
        // }
        
        // this.$refs.newOtherIcon.style.display = 'none'
        // this.$refs.newOtherIconBlue.style.display = 'initial'
        this.$router.push({ path: '/dory/topic-question-'+ this.currentTopicId})
        
      }
    },
    // 获取员工信息
    getUserInfo() {
      this.infoSpinning = true
      this.$post(api.tool.getUserInfo, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userInfoList = res.list
        }
        this.infoSpinning = false
      })
    },
    // 问题提交框显示
    questionSubmitVisible() {
      this.questionSubmitModalVisible = true
    },
     // 是否匿名
    questionTypeChange(e) {
      if(e.target.checked) {
        this.questionType = 1
      }else {
        this.questionType = 2
      }
      // console.log(this.questionType)
    },
    // 提交问题
    questionSubmitOk() {
      this.questionSubmitConfirmLoading = true
      // console.log(this.curUserId, this.question, this.questionType)
			this.$post(api.tool.addQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        question: this.question,
        type:this.questionType,
      }).then((res) => {
        if (res.code === 200) {
          this.questionSubmitConfirmLoading = false
          this.questionSubmitModalVisible = false
          this.$message.success('提交成功')
					this.question = ''
          this.questionType = 2
					this.getQuestionLast()
          this.getQuestionNum()
        }
      })
    },
    // Topic提交问题
    questionTopicSubmitOk() {
      this.questionSubmitConfirmLoading = true
      // console.log(this.curUserId, this.question, this.questionType)
			this.$post(api.tool.addTopicQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        topic_id:this.currentTopicId,
        question: this.question,
        type:this.questionType
      }).then((res) => {
        if (res.code === 200) {
          this.questionSubmitConfirmLoading = false
          this.questionSubmitModalVisible = false
          this.$message.success('提交成功')
					this.question = ''
          this.questionType = 2
					this.getTopicQuestionLast(this.currentTopicId)
          this.getTopicQuestionNum(this.currentTopicId)
        }
      })
    },
    // 取消提交
    questionSubmitCancel(){
      this.questionSubmitModalVisible = false
      // 清空问题
      this.question = ''
    },
    // 下一个问题
    nextQuestion(){
      this.$refs.question.next();
    },
		// 点赞问题 
		likeQuestion(id, hold, type) {
			// console.log(id,'状态:',hold,'类型:',type)
      // 新增状态 1
			this.operate = 1
      // 取消状态 2
			if(type == 1 && type == hold) {
				this.operate = 2
			}else if (type == 2 && type == hold) {
				this.operate = 2
			}
      // 转变状态 3
      if(hold != 0 && type != hold) {
				this.operate = 3
			}
      
			this.$post(api.tool.holdQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
				question_id:id,
				type:type,
				operate:this.operate
      }).then((res) => {
        if (res.code === 200) {
          if(res.list == '1') {
            this.$message.success('操作成功')
            this.getQuestionLast()
            this.getQuestionNum()
          }
          // else {
          //   if(type == 1) {
          //     this.$message.error('你已踩过该问题，请点击取消后再赞')
          //   }else if(type == 2) {
          //     this.$message.error('你已赞过该问题，请点击取消后再踩')
          //   }
          //   this.getQuestionLast()
          //   this.getQuestionNum()
          // }
					
        }
      })
		},
    holdTopic(id,hold,type) {
      // console.log(id,'状态:',hold,'类型:',type)
      // 新增状态 1
			this.operate = 1
      // 取消状态 2
			if(type == 1 && type == hold) {
				this.operate = 2
			}else if (type == 2 && type == hold) {
				this.operate = 2
			}
      // 转变状态 3
      if(hold != 0 && type != hold) {
				this.operate = 3
			}
			this.$post(api.tool.holdTopic, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
				question_id:id,
				type:type,
				operate:this.operate
      }).then((res) => {
        if (res.code === 200) {
          if(res.list == '1') {
            this.$message.success('操作成功')
            this.getTopicQuestionLast(this.currentTopicId)
            this.getTopicQuestionNum(this.currentTopicId)
          }
        }
      })
    },
    //已讨论问题，修改状态
    talkedQuestion(){
      this.$post(api.tool.dealQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.getQuestionLast()
          this.getQuestionNum()
          this.getHistoryQuestion()
          this.getMyselfQuestion()
        }else {
          this.$message.error('你没有权限进行次操作，请与系统管理员联系。')
        }
      })
    },
    talkedQuestionCancel(){
          this.$message.warning('操作已取消')
    },
    // 获取问题列表(1为默认最新排序，2为操作人数排序)
		getQuestionLast() {
			this.$post(api.tool.getQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        orders:1,
      }).then((res) => {
        if (res.code === 200) {
          this.questionListLast = res.list
        }
      })
		},
    getQuestionNum() {
      this.timeOffRequest = true
      this.$post(api.tool.getQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        orders:3
      }).then((res) => {
        if (res.code === 200) {
          this.timeOffRequest = false
          this.questionListNum = res.list
        }
      })
    },
    changeQuestionNum(order) {
      this.questionListOrder = order
      this.timeOffRequest = true
      this.$post(api.tool.getQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        orders:order
      }).then((res) => {
        if (res.code === 200) {
          this.timeOffRequest = false
          this.questionListNum = res.list
        }
      })
    },
    // 获取专题问题列表(1为默认最新排序，2为操作人数排序)
		getTopicQuestionLast(index) {
      this.$post(api.tool.getCurrentTopic, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        orders:this.questionListOrder
      }).then((res) => {
        if (res.code === 200) {
          this.currentTopicList = res.list.reverse()
          for(let i = 0;i < this.currentTopicList.length;i++) {
            this.iconIndexArr.push(i)
          }
          this.currentTopicList.forEach(item => {
            if(item.id == index) {
              this.currentTopicName = item.topic_heading
              this.currentTopicListLast = item.question
            }
          })
        }
      })
		},
    getTopicQuestionNum(index) {
      this.$post(api.tool.getCurrentTopic, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        orders:this.questionListOrder
      }).then((res) => {
        if (res.code === 200) {
          this.currentTopicList = res.list.reverse()
          this.currentTopicList.forEach(item => {
            if(item.id == index) {
              this.currentTopicListNum = item.question
            }
          })
        }
      })
    },
    getHistoryQuestion() {
      this.timeOffHistory = true
      this.$post(api.tool.getHistoryQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        year:this.yearValue
      }).then((res) => {
        if (res.code === 200) {
          this.timeOffHistory = false
          this.historyQuestionList = res.list
        }
      })
    },
    // 获取用户问题列表
    getMyselfQuestion() {
      this.timeOffHistory = true
      this.$post(api.tool.getMyselfQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        year: this.myselfYearValue,
      }).then((res) => {
        if (res.code === 200) {
          this.timeOffHistory = false
          this.myselfQuestionList = res.list
        }
      })
    },
    // 获取用户问题列表
    deleMyselfQuestion(question_id) {
      console.log(question_id);
      this.$post(api.tool.deleteQuestion, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        question_id: question_id,
      }).then((res) => {
        if (res.code === 200) {
          this.getMyselfQuestion();
        }
      })
    },
    cancelDeleMyselfQuestion(e){
      console.log(e);
      this.$message.error('Click on No');
    },
    // 获取权限
    getRole(){
      this.$post(api.tool.getRole,{
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if(res.code === 200) {
          res.list.forEach(item => {
            if(item.role_id == 1 && item.role_name == '管理员') {
              this.questionsDeal = true
            }
          });
        }
      })
    },

    yearChange() {
      this.getHistoryQuestion()
    },
    myselfYearChange() {
      this.getMyselfQuestion()
    },

    // 路由 - 初始化页面
    initPage() {
      console.log(this.$route.params.category);
      if(this.$route.params.category == undefined || this.$route.params.category == 'tgif-question') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'none'
          this.$refs.newIconBlue.style.display = 'initial'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.myselfIcon.style.display = 'initial'
          this.$refs.myselfIconBlue.style.display = 'none'
        })
        this.timeOffRequestVisible = true
        this.timeOffRequestTopicVisible = false
        this.timeOffHistoryVisible = false
        this.timeOffMyselfVisible= false
        this.getQuestionLast()
        this.getQuestionNum()
        this.defaultShowMenu = ['0']
      }else if (this.$route.params.category == 'topic-question') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.myselfIcon.style.display = 'initial'
          this.$refs.myselfIconBlue.style.display = 'none'
        })
        this.timeOffRequestVisible = false
        this.timeOffRequestTopicVisible = true
        this.timeOffHistoryVisible = false
        this.timeOffMyselfVisible= false

        this.currentTopicId = '1'
        this.defaultShowMenu = ['1']
        this.getTopicQuestionLast(this.currentTopicId)
        this.getTopicQuestionNum(this.currentTopicId)
      }else if (this.$route.params.category.indexOf('topic-question') !== -1 ) {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.myselfIcon.style.display = 'initial'
          this.$refs.myselfIconBlue.style.display = 'none'
        })
        this.timeOffRequestVisible = false
        this.timeOffRequestTopicVisible = true
        this.timeOffHistoryVisible = false
        this.timeOffMyselfVisible= false

        this.currentTopicId = this.$route.params.category.split('-')[2]
        this.defaultShowMenu = [this.$route.params.category.split('-')[2]]
        this.getTopicQuestionLast(this.currentTopicId)
        this.getTopicQuestionNum(this.currentTopicId)
      }else if(this.$route.params.category == 'tgif-history') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'none'
          this.$refs.historyIconBlue.style.display = 'initial'
          this.$refs.myselfIcon.style.display = 'initial'
          this.$refs.myselfIconBlue.style.display = 'none'
        })
        this.timeOffRequestVisible = false
        this.timeOffRequestTopicVisible = false
        this.timeOffHistoryVisible = true
        this.timeOffMyselfVisible= false

        this.getHistoryQuestion()
        this.defaultShowMenu = ["100"]
      }else if(this.$route.params.category == 'tgif-myself') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.myselfIcon.style.display = 'none'
          this.$refs.myselfIconBlue.style.display = 'initial'
        })
        this.timeOffRequestVisible = false
        this.timeOffRequestTopicVisible = false
        this.timeOffHistoryVisible = false
        this.timeOffMyselfVisible= true
        this.defaultShowMenu = ["200"]
        this.getMyselfQuestion()
      }
    },

  },
  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
      this.getRole()
      this.getUserInfo()
      
      this.getTopicQuestionLast('1')
      this.getTopicQuestionNum('1')

      this.initPage()
			
    } else {
      this.$router.push({ path: '/login' })
    }
  },
}
</script>

<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}
#components-layout-demo-basic >>> .leave-select .ant-select-arrow i svg {
  display: none;
}
#components-layout-demo-basic >>> .leave-select .ant-select-arrow {
    /* display: none; */
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 9px solid #2177e9;
    border-radius: 3px;
}

.container {
  /*width: 60%;*/
  width: 1120px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}
/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}
/* tab */
#components-layout-demo-basic >>> .ant-menu-vertical {
  border-right: 0;
  margin-top: 24px;
}
#components-layout-demo-basic >>> .ant-menu-item {
  height: 44px;
  width: 280px;
  background-color: #ffffff;
  border-radius: 0 22px 22px 0;
  padding-top:1px;
}
#components-layout-demo-basic >>> .ant-menu-item span {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #222222;
  margin-left: 16px;
}
#components-layout-demo-basic >>> .ant-menu-item-selected {
  background-color: #e9f0fd;
  border-radius: 0 22px 22px 0;
}
#components-layout-demo-basic >>> .ant-menu-item-selected span {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #1a73e8;
}
/* avatar name */
.info-prof {
  height: 81px;
}
.info-prof-avatar {
  margin-top: 5px;
  margin-left: 4px;
  width: 72px;
  height: 72px;
}
.info-prof-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
.info-prof-name {
  height: 16px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  line-height: 19px;
  color: #222222;
  margin-top: 23px;
}
.info-prof-offer {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  margin-top: 10px;
}
.leave {
  display: flex;
  margin-top: 40px;
}
.leave-menu {
  width: 320px;
}
.timeoff-request {
  background-color: #ffffff;
  box-shadow: 0px 0px 12px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  width: 800px;
  margin-bottom:50px;
}
.request-title {
  height: 86px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
  line-height: 86px;
  padding-left: 31px;
  padding-right:31px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.request-title a {
  font-size:16px;
  font-family: GoogleSans-Medium;
}
.request-title a:hover {
  text-decoration: underline;
}
.request-content {
  /* height: 660px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding: 20px 32px 20px 32px;
}
#components-layout-demo-basic >>> .ant-calendar-picker {
  width: 100%;
}
#components-layout-demo-basic >>> .ant-calendar-picker-icon {
  display: none;
}
#components-layout-demo-basic >>> .ant-select {
  height: 40px;
  width: 100%;
}
#components-layout-demo-basic >>> .ant-input {
  height: 40px;
  border-radius: 8px;
}
#components-layout-demo-basic >>> .ant-select-selection.ant-select-selection--single,
#components-layout-demo-basic >>> .ant-select-selection__rendered {
  height: 40px;
  border-radius: 8px;
}
#components-layout-demo-basic >>> .ant-select-selection__rendered {
  line-height: 36px;
}
#components-layout-demo-basic >>> .comments-input.ant-input {
  height: 184px;
  padding-top:10px;
}
.timeoff-history {
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
}
.timeoff-history-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.history-title-text {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}
.tgif-question {
	width:100%;
	display: flex;
  flex-direction: column;
  color:#bbbbbb;
	justify-content: space-between;
}
.qusetion-submit {
	display: flex;
	align-items: center;
	justify-content: center;
	width:15%;
	text-align: center;
	background-color: #2177e9;
	border-radius: 10px;
	color:#ffffff;
	cursor: pointer;
}
.tgif-list-item-like,
.tgif-list-item-dislike{
  width:65px;
  height:65px;
	display: flex;
  justify-content: center;
	align-items: center;
  border:1px solid #cccccc;
  cursor: pointer;
  border-radius: 4px;
}
.tgif-list-item-like:hover {
  background: #45b97c !important;
}
.tgif-list-item-like:hover svg {
  fill:#ffffff;
}
.tgif-list-item-dislike:hover {
  background: #ed1941 !important;
}
.tgif-list-item-dislike:hover svg {
  fill:#ffffff;
}
#components-layout-demo-basic >>> .submit-btn {
  font-size: 14px;
  width:150px;
  height:40px;
  line-height:40px;
  text-align: center;
  background:#2177e9;
  color:#fff;
  border-radius:8px;
  border:none;
  cursor: pointer;
}
#components-layout-demo-basic >>> .slick-track {
  display: flex;
  align-items: center;
}
#components-layout-demo-basic >>> .ant-carousel .slick-slider {
  height:100%;
}
.question-content {
  font-family: GoogleSans-Medium;
  font-size: 20px;
  max-width: 500px;
  /* min-height:162px; */
  min-height:136px;
  display: flex;
  align-items: center;
}
.question-card-wrap {
  width:100%;
  min-height:200px;
  border: 2px solid #bbbbbb;
  border-radius:8px;
  padding:25px;
  margin-top:15px;
}
.question-card {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}
.question-select-wrap {
  width:150px;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
}
.question-title {
  font-family: GoogleSans-Medium;
  font-size: 18px;
  margin-bottom:2px;
}
.question-selection {
  display:flex;
  justify-content: space-between;
  margin-bottom:10px;
}
.question-skip {
  width:100%;
  font-family: GoogleSans-Medium;
}
.view-report-content {
  display:flex;
  justify-content:space-between;
}
.question-list {
  margin-top:10px;
}
.question-item,
.question-item-history  {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
}
.question-item-history {
  border-bottom:2px solid #cccccc;
  padding-bottom:20px;
  margin-bottom:20px;
}
.question-item-content {
  font-size: 16px;
  max-width:550px;
}
.question-item-result {
  width:150px;
  height:60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.question-item-select-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height:25px;
  cursor: pointer;
}
.question-item-select-wrap.history {
  cursor: auto;
}
.question-correct-width,
.question-wrong-width{
  height:20px;
  flex:1;
  padding:0 10px;
}
.question-correct-width span {
  display:inline-block;
  height:100%;
  background: #45b97c;
}
.question-wrong-width span {
  display:inline-block;
  height:100%;
  background: #ed1941;
}
.question-correct-num,
.question-wrong-num{
  min-width:21px;
}
.timeoff-history-content .question-item {
  /* color:#aaaaaa; */
}
.timeoff-history-content .question-correct-width span {
  /* background: #aaaaaa; */
}
.timeoff-history-content .question-wrong-width span {
  /* background: #dddddd; */
}

#components-layout-demo-basic >>> .year-select {
 width:90px;
  margin-right:24px;
}
#components-layout-demo-basic >>> .year-select .ant-select-selection__rendered {
  line-height:38px;
}
#components-layout-demo-basic >>> .year-select .ant-select-selection {
  width:90px;
}

</style>
